/* src/app/pages/ui-kit/components/filters-view/filters-view.component.scss */
.box {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 30px;
}
/*# sourceMappingURL=filters-view.component.css.map */
